"use strict";
/**
 * Created by Hayk.Andriasyan on 5/23/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var PagingCriteria = /** @class */ (function () {
    function PagingCriteria(isAllOrOffset, count) {
        if (typeof isAllOrOffset === 'boolean') {
            this._isAll = true;
            this.count = null;
            this.offset = null;
        }
        else {
            this._isAll = false;
            this.count = count;
            this.offset = isAllOrOffset;
        }
    }
    /**
     * Fetch all rows
     */
    PagingCriteria.all = function () {
        return new PagingCriteria(true);
    };
    /**
     * @param offset count of rows to skip
     * @param count  count of rows to fetch
     */
    PagingCriteria.of = function (offset, count) {
        return new PagingCriteria(offset, count);
    };
    /**
     * Fetch all data
     */
    PagingCriteria.prototype.isAll = function () {
        return this._isAll;
    };
    PagingCriteria.prototype.toJson = function () {
        var jsonString;
        jsonString = JSON.stringify({
            isAll: this._isAll,
            count: this.count,
            offset: this.offset
        });
        return jsonString;
    };
    return PagingCriteria;
}());
exports.PagingCriteria = PagingCriteria;
//# sourceMappingURL=paging-criteria.js.map